import { render, staticRenderFns } from "./BaseNotice.vue?vue&type=template&id=5b19ef8c&scoped=true&"
import script from "./BaseNotice.vue?vue&type=script&lang=js&"
export * from "./BaseNotice.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotice.vue?vue&type=style&index=0&id=5b19ef8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b19ef8c",
  null
  
)

export default component.exports